// extracted by mini-css-extract-plugin
export var permissionsTitle = "InviteForm-module--permissionsTitle--ZR5JI";
export var tabContentTitle = "InviteForm-module--tabContentTitle--XSdNq";